import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { NotFoundComponent } from './not-found/not-found.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { LogoutComponent } from './logout/logout.component';

const routes: Routes = [
  { path: '404', component: NotFoundComponent },
  { path: 'accessDenied', component: AccessDeniedComponent },
  { path: 'maintenance', component: MaintenanceComponent },
  { path: 'loggedOut', component: LogoutComponent },
  { path: 'coming-soon', component: MaintenanceComponent, data: { comingSoon: true } },
  { path: 'no-modules', component: NotFoundComponent, data: { noModules: true } },
];

@NgModule({
  declarations: [
    NotFoundComponent,
    AccessDeniedComponent,
    MaintenanceComponent,
    LogoutComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
  exports: [
    NotFoundComponent,
    AccessDeniedComponent,
    MaintenanceComponent,
    LogoutComponent,
  ],
})
export class PagesModule {}
